var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "header",
    [
      _vm.step >= 2
        ? _c("p", { staticClass: "amount" }, [
            _c("span", [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.donorInformation["donation-amount"]) +
                  "\n    "
              ),
            ]),
            _vm._v(
              "\n    " +
                _vm._s(
                  this.donorInformation["allow-monthly-donation"]
                    ? "monthly"
                    : "once only donation"
                ) +
                "\n  "
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.step >= 3
        ? _c("div", { staticClass: "donor" }, [
            _c(
              "div",
              { staticClass: "inner" },
              [
                _c("p", [_vm._v(_vm._s(_vm.displayName))]),
                _vm._v(" "),
                _vm.step === 3 &&
                _vm.donorInformation["donor-type"] === "individual"
                  ? _c(
                      "el-button",
                      { attrs: { type: "plain" }, on: { click: _vm.openEdit } },
                      [
                        _c("img", {
                          staticClass: "edit-ico",
                          attrs: {
                            src: require("../../assets/icons/edit.svg"),
                            alt: "",
                          },
                        }),
                        _vm._v("\n        Edit"),
                      ]
                    )
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _vm.step >= 4 && _vm.showAddress
              ? _c("p", [
                  _c("i", { staticClass: "el-icon-location-outline" }),
                  _vm._v("\n      " + _vm._s(_vm.getAddress) + "\n    "),
                ])
              : _vm._e(),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.step === 3
        ? _c(
            "el-form",
            {
              staticClass: "edit-name",
              class: { isActive: _vm.editState },
              on: { submit: _vm.save },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "First Name" },
                        model: {
                          value: _vm.firstName,
                          callback: function ($$v) {
                            _vm.firstName = $$v
                          },
                          expression: "firstName",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "Last Name" },
                        model: {
                          value: _vm.lastName,
                          callback: function ($$v) {
                            _vm.lastName = $$v
                          },
                          expression: "lastName",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "mini" },
                  on: { click: _vm.save },
                },
                [_vm._v("save")]
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }